import { render, staticRenderFns } from "./TrueFalseChoice.vue?vue&type=template&id=4bc1aa08&"
import script from "./TrueFalseChoice.vue?vue&type=script&lang=js&"
export * from "./TrueFalseChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc1aa08')) {
      api.createRecord('4bc1aa08', component.options)
    } else {
      api.reload('4bc1aa08', component.options)
    }
    module.hot.accept("./TrueFalseChoice.vue?vue&type=template&id=4bc1aa08&", function () {
      api.rerender('4bc1aa08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/TrueFalseChoice.vue"
export default component.exports